import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  DisablableOption,
} from "@models";
import { 
  Character,
  CharacterItem,
  CharacterContainer,
  Armor,
  SubscriptionType,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import CheckBox from "@components/input/CheckBox";
import ViewItem from "@dndComponents/display/ViewItem";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  character: Character;
  item: CharacterItem;
  disabled: boolean;
  onOpen: () => void;
  log_it?: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterViewInventoryItem({
  character,
  item,
  disabled,
  onOpen,
  log_it
}: Props) {
  // const [reloading, setReloading] = useState(false);
  const [ping, setPing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  // useEffect(() => {
  //   if (!fetched) {
  //     setFetched(true);
  //     character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  //     character.subscription_holder.subscribe("Items", mounted, recalculated);
  //   }
  // });
  // useEffect(() => {
  //   if (log_it) {
  //     debugger;
  //   }
  //   const load = () => {
  //     character.subscription_holder.subscribe("Recalculated", mounted, recalculated);
  //     character.subscription_holder.subscribe("Items", mounted, recalculated);
  //   };

  //   load();
  // }, [log_it]);

  // const recalculated = (triggered_by: SubscriptionType, from_recalc: boolean) => {
  //   if (log_it) {
  //     debugger;
  //   }
  //   if (!from_recalc || triggered_by !== "Items") {
  //     console.log(`${triggered_by}: ${item.name}`);
  //     setPing(!ping);
  //   }
  // }

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);
  
  if (log_it) {
    console.log(item);
  }
  if (item instanceof CharacterContainer) {
    return (
      <Grid container spacing={0} direction="row" className="header">
        <Grid
          style={{
            fontSize: "12px",
            paddingLeft: "4px"
          }}
          className="header clickable"
          onClick={onOpen}
          size={{
            xs: 2
          }}>
          <ViewItem item={item} character={character} />
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          { !["Equipment","Storage"].includes(item.true_id) &&
            <CheckBox 
              name=""
              value={item.equipped} 
              onChange={(changed: boolean) => {
                const char_item = character.items.find(o => o.true_id === item.true_id);
                if (char_item) {
                  if (changed) {
                    connect_util.equipItem(character, char_item);
                  } else {
                    connect_util.unequipItem(character, char_item);
                  }
                  setPing(!ping);
                }
              }} 
            />
          }
        </Grid>
        <Grid
          size={{
            xs: 5
          }}></Grid>
        <Grid
          size={{
            xs: 4
          }}>
          { item.max_weight > 0 ? 
            <span style={{
              color: Math.round(item.content_weight*100)/100 > item.max_weight ? 'red' : 'inherit'
            }}>{ Math.round(item.content_weight*100)/100 }/{ item.max_weight } lbs&nbsp;</span>
          : 
            <span>{ Math.round(item.content_weight*100)/100 } lbs&nbsp;</span>
          }
          { !["Equipment","Storage"].includes(item.true_id) && 
            <span>(Container Weight: { item.weight } lbs)</span>
          }
        </Grid>
        {/* { renderExtras() } */}
      </Grid>
    );
  } else {
    // if (item.name.includes("Bloodwe")) {
    //   debugger;
    // }
    // console.log(item.name);
    const can_equip = char_util.canEquip(character, item);
    const options: DisablableOption[] = character.containers.filter(o => 
      item.in_char_container_id !== o.true_id).map(o => { return { text: o.name, id: o.true_id }});
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 1
          }}>
          { item.base_item && 
            item.base_item.item_type === "Armor" && item.base_item instanceof Armor ? 
            <CheckBox 
              name=""
              value={item.equipped} 
              tooltip={
                !can_equip ? 
                "You are not proficient in this item" : 
                ((item.base_item.armor_type_name === "Shield" && character.shield_carried) ? 
                  "You already have a Shield equipped" : 
                  ((item.base_item.armor_type_name !== "Shield" && character.armor_worn) ? 
                    "You already have Armor equipped": ""
                  )
                )
              }
              disabled={ !item.equipped && (!can_equip || (item.base_item.armor_type_name === "Shield" && character.shield_carried) || (item.base_item.armor_type_name !== "Shield" && character.armor_worn)) }
              onChange={(changed: boolean) => {
                const char_item = character.items.find(o => o.true_id === item.true_id);
                if (char_item) {
                  if (changed) {
                    connect_util.equipItem(character, char_item);
                  } else {
                    connect_util.unequipItem(character, char_item);
                  }
                  setPing(!ping);
                }
              }} 
            />
          : item.equippable ? 
            <CheckBox 
              name=""
              value={item.equipped} 
              disabled={!item.equipped && !can_equip}
              onChange={(changed: boolean) => {
                const char_item = character.items.find(o => o.true_id === item.true_id);
                if (char_item) {
                  if (changed) {
                    connect_util.equipItem(character, char_item);
                  } else {
                    connect_util.unequipItem(character, char_item);
                  }
                  setPing(!ping);
                }
              }} 
            />
          :
            <span>&nbsp;--</span>
          }
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          <SelectStringBox 
            name="Move To"
            value={""}
            options={options}
            small
            onChange={(changed: string) => {
              connect_util.moveItem(character, item, changed);
              setPing(!ping);
              // onChange();
            }}
          />
        </Grid>
        <Grid
          onClick={() => {
            if (!disabled) {
              onOpen();
            }
          }}
          size={{
            xs: 6
          }}>
          { <ViewItem item={item} character={character} /> }
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          { (item.weight > 0 ? <span>{ item.weight }</span> : <span>--</span>) }
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          { <span>{ item.count }</span> }
        </Grid>
        <Grid
          size={{
            xs: 1
          }}>
          { (item.cost > 0 ? <span>{ item.cost }</span> : <span>--</span>) }
        </Grid>
        <Grid
          style={{ overflowX: "hidden" }}
          size={{
            xs: 1
          }}>
          { item.item_type }
        </Grid>
        {/* { renderExtras() } */}
      </Grid>
    );
  }
}
